import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import axios from "../../API/axios";
import { getOwnCompaniesList } from "../../Services/apiService";
import { debounce } from "lodash";
import Select from "react-select";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useTranslation } from "react-i18next";
const OfferAJobs = ({ openModal, closeModal, userUid, userData }) => {
  const sessionId = localStorage.getItem("sessionId");
  const [display, setDisplay] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const { t } = useTranslation();
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //********Company List Start  ********//
  const [companyData, setCompanyData] = useState([]);
  const [companyId, setCompanyId] = useState(null);
    const [isloading, setIsloading] = useState(false);
  
const language = localStorage.getItem("Lang");
  const [jobsData, setJobsData] = useState([]);
  const [jobId, setJobId] = useState(null);
  const getCompany = async () => {
    try {
      const res = await getOwnCompaniesList();
      console.log(res);
      const data = res.map((item) => ({
        value: item.compUid,
        label: item.compName,
      }));
      setCompanyData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
 if (userData?.profileInfo?.isOwn === true) {
    getCompany();
 }
  }, []);

  const getJobs = async () => {
    try {
      const data = {
        deviceType: "Web",
        CompUid: companyId,
        pageNumber: 1,
        pageSize: 1,
      };
      axios
        .get(
          `JobsBy/Company?DeviceType=Web&CompUid=${companyId}&pageNumber=1&pageSize=1&langKey=${language}`
        )
        .then((response) => {
          console.log(response?.data?.responseData);
          const res = response?.data?.responseData?.viewJobs;
          const data = res?.map((item) => ({
            value: item?.jobId,
            label: item?.title,
          }));
          setJobsData(data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (companyId) {
      getJobs();
    }
  }, [companyId]);

  const offerJobAfterApiCall = () => {
    closeModal();
    setCompanyId(null);
    setJobId(null);
  };

  const offerAJobApiCall = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      userUid: userUid,
      compUID: companyId,
      langKey: language === "en" ? "" : language,
    };
    try {
    setIsloading(true);

      await axios
        .post(`/JobAction/OfferJob`, responseData) //offer a job api call to be here
        .then((res) => {
          offerJobAfterApiCall();
          setToastMessage(res.data.message);
          setShowToast(true);
        });
       setIsloading(false);

    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
        offerJobAfterApiCall();
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
        offerJobAfterApiCall();
      }
    }
  };


  useEffect(() => {
    if (openModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  
    return () => {
      document.body.classList.remove("modal-open"); // Cleanup on modal close
    };
  }, [openModal]);

  return (
    <div>
      {openModal && (
        <div
          className="modal fade show postAdd jobCreate"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around ">
              <div className="setting-header d-flex justify-content-between align-items-center">
                <h6>{t("Newsfeed.Offer a Job")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    closeModal();
                  }}
                />
              </div>
              <div className="bs-stepper">
                <div className="bs-stepper-content p-0">
                  <Row>
                    <Col md={12}>
                      <Form>
                        <div className="row p-4 pt-0 settings CreateCompany  p-0">
                          <div className="col-md-12 mt-2">
                              {t("Newsfeed.Company Name")}
                            <label htmlFor="about">
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select

                              defaultValue={companyId}
                              onChange={(e) => {
                                setCompanyId(e.value);
                              }}
                              options={companyData}
                              placeholder={t("Newsfeed.Select Company Name")}
                              styles={customStyles}
                            />
                            {display && !companyId ? (
                              <span className="error_msg_lbl">
                               {t("Newsfeed.Select Company Name")}
                              </span>
                            ) : null}
                          </div>
                          {companyId && (
                            <div className="col-md-12 mt-2">
                              <label htmlFor="about">
                               {t("Newsfeed.Select Job")} 
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                defaultValue={jobId}
                                onChange={(e) => {
                                  setJobId(e.value);
                                }}
                                options={jobsData}
                                placeholder={t("Newsfeed.Select Job")}
                                styles={customStyles}
                              />
                              {display && !jobId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Job")}
                                </span>
                              ) : null}
                            </div>
                          )}
                        </div>
                        <div className="p-4 col-md-12 text-end mt-4">
                          <button
                            type="button"
                            className="mainBtn1"
                            onClick={() => {
                              offerAJobApiCall();
                            }}
                            disabled={companyId === null || jobId === null}
                          >
                             {t("Newsfeed.Next")}
                  {isloading === true ? t("Newsfeed.Posting") : t("Newsfeed.Post")}

                          </button>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </div>
  );
};

export default OfferAJobs;
